import type { FC } from 'react';

import { ExperimentChatProvider } from '@apps/chatv2-shared-multilabel';
import type { AppProps } from '@eneco/next';
import { SessionProvider } from 'next-auth/react';

const EXPERIMENT_NAME = 'eneco-chatbot-v2';

const MKBApp: FC<AppProps> = ({ Component, pageProps: { session, featureVariants, ...pageProps }, router }) => {
  const isEnecoChatEnabled = featureVariants?.[EXPERIMENT_NAME] ?? true;

  return (
    <SessionProvider session={session} basePath={`${router.basePath}/api/auth`}>
      <ExperimentChatProvider
        isEnabled={isEnecoChatEnabled}
        defaultNamespace="eneco-nl-b2c"
        authenticated={true}
        loginRedirectUrl="/mijn-eneco">
        <Component {...pageProps} />
      </ExperimentChatProvider>
    </SessionProvider>
  );
};

export default MKBApp;
